import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import EmailPipelineContent from '../components/EmailPipelineContent';
import StoreScopedFeaturePage from '../../storeDetails/components/StoreScopedFeaturePage';
import { STORE_DETAILS_TAB_PARAM } from '../../storeDetails/utils/storeDetailsQueryParams';
import {
  EMAIL_PIPELINE_STORE_PARAM,
} from '../utils/emailPipelineQueryParams';

const EmailPipelinePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const selectedStoreId = searchParams.get(EMAIL_PIPELINE_STORE_PARAM) || '';

  if (selectedStoreId) {
    const nextParams = new URLSearchParams(location.search);
    nextParams.delete(EMAIL_PIPELINE_STORE_PARAM);
    nextParams.set(STORE_DETAILS_TAB_PARAM, 'email_pipeline');

    return (
      <Navigate
        to={{
          pathname: `/dashboard/store-summary/stores/${selectedStoreId}`,
          search: nextParams.toString() ? `?${nextParams.toString()}` : '',
        }}
        replace
      />
    );
  }

  return (
    <StoreScopedFeaturePage
      storeId={selectedStoreId || undefined}
      backLabel="Pipeline Status"
      backPath="/dashboard/store-summary"
      activeTab="email_pipeline"
    >
      <EmailPipelineContent storeId={selectedStoreId || undefined} lockStoreSelection={Boolean(selectedStoreId)} />
    </StoreScopedFeaturePage>
  );
};

export default EmailPipelinePage;
